/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PageSportsClubSearchResultDto } from '../models/PageSportsClubSearchResultDto';
import type { SportsClubSearchCriteriaDto } from '../models/SportsClubSearchCriteriaDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class SportsClubControllerService {
    /**
     * @returns SportsClubDetailsDto OK
     * @throws ApiError
     */
    public static getMyDetails(): CancelablePromise<{
        id?: number;
        username?: string;
        regon?: string;
        nip?: string;
        name?: string;
        voivodeship?: string;
        county?: string;
        city?: string;
        latitude?: number;
        longitude?: number;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/sports-clubs/my-details',
        });
    }
    /**
     * @param id
     * @returns SportsClubDetailsDto OK
     * @throws ApiError
     */
    public static getSportsClubDetailsById(
        id: number,
    ): CancelablePromise<{
        id?: number;
        username?: string;
        regon?: string;
        nip?: string;
        name?: string;
        voivodeship?: string;
        county?: string;
        city?: string;
        latitude?: number;
        longitude?: number;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/sports-clubs/{id}/details',
            path: {
                'id': id,
            },
        });
    }
    /**
     * @param requestBody
     * @param page
     * @param size
     * @returns PageSportsClubSearchResultDto OK
     * @throws ApiError
     */
    public static searchSportsClubs(
        requestBody: SportsClubSearchCriteriaDto,
        page?: number,
        size: number = 10,
    ): CancelablePromise<PageSportsClubSearchResultDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/sports-clubs/search',
            query: {
                'page': page,
                'size': size,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
